import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    CashBySegment,
    EliminationBalanceSheet,
    EliminationIncomeStatement,
    InterSegmentInterestPreview,
    InterSegmentLoan,
    InterSegmentLoanCreate,
    InterSegmentMoneyEvent,
    InterSegmentReconciliation,
    InterSegmentResidualAllocation,
    InterSegmentSettings,
    SuggestedAccountsResult,
} from '../interfaces/interSegment.interface';

const E = ENDPOINTS.INTER_SEGMENT;

export const InterSegmentService = {
    getSettings: async (institutionId: string): Promise<InterSegmentSettings> =>
        (await axios.get(E.SETTINGS(institutionId))).data,
    saveSettings: async (dto: InterSegmentSettings): Promise<InterSegmentSettings> =>
        (await axios.put(E.SETTINGS_SAVE, dto)).data,
    createSuggestedAccounts: async (institutionId: string): Promise<SuggestedAccountsResult> =>
        (await axios.post(E.SUGGESTED_ACCOUNTS(institutionId))).data,

    listLoans: async (institutionId: string): Promise<InterSegmentLoan[]> =>
        (await axios.get(E.LOANS(institutionId))).data,
    getLoan: async (loanId: string): Promise<InterSegmentLoan> => (await axios.get(E.LOAN(loanId))).data,
    createLoan: async (dto: InterSegmentLoanCreate): Promise<InterSegmentLoan> =>
        (await axios.post(E.LOAN_CREATE, dto)).data,
    advance: async (loanId: string, dto: InterSegmentMoneyEvent): Promise<InterSegmentLoan> =>
        (await axios.post(E.ADVANCE(loanId), dto)).data,
    repay: async (loanId: string, dto: InterSegmentMoneyEvent): Promise<InterSegmentLoan> =>
        (await axios.post(E.REPAYMENT(loanId), dto)).data,
    previewInterest: async (loanId: string, periodTo: string): Promise<InterSegmentInterestPreview> =>
        (await axios.get(E.INTEREST_PREVIEW(loanId), { params: { periodTo } })).data,
    postInterest: async (loanId: string, periodTo: string, description?: string): Promise<InterSegmentLoan> =>
        (await axios.post(E.INTEREST(loanId), { periodTo, description })).data,
    reverseEvent: async (loanId: string, eventId: string, reason?: string): Promise<InterSegmentLoan> =>
        (await axios.post(E.REVERSE_EVENT(loanId, eventId), { reason })).data,
    closeLoan: async (loanId: string): Promise<InterSegmentLoan> => (await axios.post(E.CLOSE(loanId))).data,
    allocateResidual: async (dto: InterSegmentResidualAllocation): Promise<InterSegmentLoan> =>
        (await axios.post(E.ALLOCATE, dto)).data,

    reconciliation: async (institutionId: string, asOf?: string): Promise<InterSegmentReconciliation> =>
        (await axios.get(E.RECONCILIATION(institutionId), { params: { asOf } })).data,
    eliminationBalanceSheet: async (institutionId: string, asOf?: string): Promise<EliminationBalanceSheet> =>
        (await axios.get(E.ELIMINATION_BS(institutionId), { params: { asOf } })).data,
    eliminationIncomeStatement: async (institutionId: string, from: string, to: string): Promise<EliminationIncomeStatement> =>
        (await axios.get(E.ELIMINATION_IS(institutionId), { params: { from, to } })).data,
    cashBySegment: async (institutionId: string, asOf?: string): Promise<CashBySegment> =>
        (await axios.get(E.CASH_BY_SEGMENT(institutionId), { params: { asOf } })).data,
};
